import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import NameField from "../name-field/NameField";

interface FirstNameFieldProps {
    register: UseFormRegisterReturn;
    error?: string;
    disabled?: boolean;
    width?: string;
    id?: string;
    className?: string;
}

const FirstNameField = (props: FirstNameFieldProps) => {
    return <NameField {...props} type="first" />;
};

export default FirstNameField;
